var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.49 19.6C15 21.5 13.9 22 12.55 22h-1.09c-1.35 0-2.46-.5-2.94-2.41l-.034-.178a.5.5 0 0 1 .662-.566c1.189.436 2.14.654 2.853.654 1.32 0 2.59-.33 3.71-.98l-.22 1.08zM12 4.5c-1.35 0-2.61.36-3.7.99l.22-1.08C9 2.5 10.11 2 11.46 2h1.09c1.35 0 2.45.5 2.94 2.4l.04.188a.5.5 0 0 1-.664.57C13.69 4.72 12.736 4.5 12 4.5z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12c0 2.1.99 3.96 2.53 5.15h.01c1.1.85 2.47 1.35 3.96 1.35 1.51 0 2.89-.51 3.99-1.37H16A6.509 6.509 0 0 0 18.5 12a6.5 6.5 0 1 0-13 0zm7.9 2.6c-.19 0-.38-.07-.53-.22l-1.4-1.4a.75.75 0 0 1-.22-.53V9.66c0-.41.34-.75.75-.75s.75.34.75.75v2.48l1.18 1.18c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldWatch);
export default __webpack_public_path__ + "static/media/vuesax-bold-watch.66de5280bc46b5d5c4b0e29d91f05746.svg";
export { ForwardRef as ReactComponent };